export default {
    embassy: 'Ambassade de France en Fédération de Russie',
    address: '45, rue Bolchaïa Yakimanka 115127 Moscou',
    contacts: 'Contacts',
    department: 'Département des bourses',
    supported: 'Avec le soutien du gouvernement français'
}